export default [ {
  path: '/departments',
  name: 'Departments',
  meta: {
    title: 'TabTitle.departments',
  },
  component: () => import('@/pages/departments.vue'),
} ];
